module.exports = __webpack_public_path__ + "media/images/course/7-ccee9618e1775388d07fe0f4843f2f40.png";